import { createContext, useState } from "react";
import { setToLocalStorage } from "../../lib/localStorage";

const ThemeContext = createContext();

export function ThemeContextProvider({ children }) {
  const initialState = JSON.parse(localStorage.getItem("theme")) || false;

  const [dark, setDark] = useState(initialState);

  const changeTheme = (specifiedThemeValue = null) => {
    if (specifiedThemeValue !== null) {
      setToLocalStorage("theme", specifiedThemeValue);
      setDark(specifiedThemeValue);
      return;
    }
    setToLocalStorage("theme", !dark);
    setDark((prev) => !prev);
  };

  const valueToShare = {
    changeTheme: changeTheme,
    dark: dark,
  };

  return (
    <ThemeContext.Provider value={valueToShare}>
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeContext;
